<mpro-modal
  class="gradient-background"
  *ngIf="isModalOpen"
  [(open)]="isModalOpen"
  (openChange)="onModalClose()"
>
  <main id="freemium-pay-wall" class="container-sm">
    <section class="row">
      <div class="col-lg-6">
        <img id="profile-img" src="assets/dark-logo.svg" />
        <h2>Contact our sales <br />team, and <b>just ask</b></h2>
        <p>
          We are happy to answer questions and get you acquainted with World
          Data Pro
        </p>
        <ul>
          <li>Learn how World Data Pro could enhance your work</li>
          <li>Get pricing information</li>
          <li>Explore use cases for your team</li>
        </ul>
        <button
          class="mpro-btn mpro-btn-primary"
          (click)="authService.requestCallBack()"
        >
          SUBMIT REQUEST
        </button>
      </div>
      <div class="col-lg-6 relative">
        <img src="/assets/laptop-png.png" id="laptop" />
      </div>
    </section>
    <section class="row">
      <div class="col-12">
        <h3>Trusted by</h3>
        <div class="flex">
          <img src="assets/logo/loreal.svg" />
          <img src="assets/logo/deloitte.svg" />
          <img src="assets/logo/barclays.svg" />
          <img src="assets/logo/iom.svg" />
          <img src="assets/logo/colgate-palmolive.svg" />
          <img src="assets/logo/hsbc.svg" />
        </div>
        <h3>Featured by</h3>
        <div class="flex">
          <img src="assets/logo/thewallstreetjournal.svg" />
          <img src="assets/logo/bloomberg.svg" />
          <img src="assets/logo/brookings.svg" />
          <img src="assets/logo/thewashingtonpost.svg" />
          <img src="assets/logo/theguardian.svg" />
          <img src="assets/logo/theeconomist.svg" />
        </div>
      </div>
    </section>
  </main>
</mpro-modal>
